import { createContext, useState } from 'react';
import * as React from 'react';
import { TComment } from '../models/common';

interface ICommentContext {
  comments: TComment[];
  setComments: React.Dispatch<React.SetStateAction<TComment[]>>;
}

export const CommentContext = createContext<ICommentContext>({
  comments: [],
  setComments: (value: any) => undefined,
});

export const CommentContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [comments, setComments] = useState<TComment[]>([]);

  return (
    <CommentContext.Provider
      value={{
        comments,
        setComments,
      }}
    >
      {children}
    </CommentContext.Provider>
  );
};
